import React, { useEffect, useRef, useCallback, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

//const UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

const SidebarContent = props => {
  const ref = useRef()
  const navigate = useNavigate()

  const [profileURL, setProfileURL] = useState("/profile")
  const [userType, setUserType] = useState(
    JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))
  )
  useEffect(() => {
    const handleStorageChange = () => {
      setUserType(JSON.parse(localStorage.getItem("WWINGS_USER_TYPE")))
    }

    window.addEventListener("storage", handleStorageChange)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [])

  useEffect(() => {
    if (userType === "Employee") {
      setProfileURL("/employee-profile")
    } else {
      setProfileURL("/profile")
    }
  }, [userType])

  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function tToggle() {
    //To close and open sidebar
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } //else {
    //   body.classList.toggle("vertical-collpsed")
    //   body.classList.toggle("sidebar-enable")
    // }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled mt-5" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" onClick={tToggle}>
                <i className='bx bxs-dashboard'></i>
                <span>{props.t("Graphs")}</span>
              </Link>
            </li>
            {userType === "Employee" ? (
              <li>
                <Link to="/target/Dashboard" onClick={tToggle}>
                  <i className="bx bxs-dashboard"></i>
                  <span>{props.t("Target")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}


            <li>
              <Link to={"/nda-aggrement"} onClick={tToggle}>
                <i className='bx bx-book-content'></i>
                <span>{props.t("NDA Agreement")}</span>
              </Link>
            </li>


            <li>
              <Link to={profileURL} onClick={tToggle}>
                <i className='bx bxs-user-detail'></i>
                <span>{props.t("Profile")}</span>
              </Link>
            </li>

            <li>
              <Link to="/reports" onClick={tToggle}>
                <i className='bx bx-book-content'></i>
                <span>{props.t("Reports")}</span>
              </Link>
            </li>

            <li>
              <Link to="/policy-reports" onClick={tToggle}>
                <i className="bx bx-detail"></i>
                <span>{props.t("Policy Reports")}</span>
              </Link>
            </li>

            <li>
              <Link to="/mutualFund-reports" onClick={tToggle}>
                <i className="bx bx-detail"></i>
                <span>{props.t("Mutual Fund Reports")}</span>
              </Link>
            </li>

            <li>
              <Link to="/leads" onClick={tToggle}>
                <i className="bx bx-user-plus"></i>
                <span>{props.t("Leads")}</span>
              </Link>
            </li>
            <li>
              <Link to="/customer" onClick={tToggle}>
                <i className="bx bx-user-circle"></i>
                <span>{props.t("Customer")}</span>
              </Link>
            </li>
            {userType === "Employee" ? (
              ""
            ) : (
              <li>
                <Link to="/employee" onClick={tToggle}>
                  <i className="bx bx-user"></i>
                  <span>{props.t("My Team")}</span>
                </Link>
              </li>
            )}
            <li>
              <Link to="/cross-sell" onClick={tToggle}>
                <i className="bx bx-store"></i>
                <span>{props.t("Cross Sell")}</span>
              </Link>
            </li>

            <li>
              <Link to="/up-sell" onClick={tToggle}>
                <i className="bx bx-bitcoin"></i>
                <span>{props.t("Up Sell")}</span>
              </Link>
            </li>

            <li>
              <Link to="/renewal-tracking" onClick={tToggle}>
                <i className="bx bx-credit-card-alt"></i>
                <span>{props.t("Renewal Tracking")}</span>
              </Link>
            </li>

            <li>
              <Link to="/customer-search" onClick={tToggle}>
                <i className="bx bx-briefcase-alt-2"></i>
                <span>{props.t("Single view of Customer")}</span>
              </Link>
            </li>
            <li>
              <Link to="/Claims" onClick={tToggle}>
                <i className="bx bx-receipt"></i>
                <span>{props.t("Claims")}</span>
              </Link>
            </li>
            <li>
              <Link to="/CalculateInsuranceNeed" onClick={tToggle}>
                <i className="bx bx-task"></i>
                <span>{props.t("Financial Planner")}</span>
              </Link>
            </li>

            <li>
              <Link to="/renewal-trigger" onClick={tToggle}>
                <i className='bx bx-calendar-plus'></i>
                <span>{props.t("Renewal Track Trigger")}</span>
              </Link>
            </li>


            <li>
              <Link to="/references" onClick={tToggle}>
                <i className='bx bx-user-voice'></i>
                <span>{props.t("References")}</span>
              </Link>
            </li>


            {userType === "Employee" ? (
              ""
            ) : (
              <li>
                <Link to="/" className="has-arrow">
                  <i className='bx bxs-lock-open-alt'></i>
                  <span>{props.t("Access Control")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/addprofile" onClick={tToggle}>
                      <i className="bx bxs-detail" />

                      <span>{props.t("Add Profile")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/assignprofile" onClick={tToggle}>
                      <i className="bx bxs-detail" />

                      <span>{props.t("Assign Profile")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            )}



            {/* <li>
              <Link 
              to="/markating-tools"
              onClick={tToggle}
              >
                <i className="bx bx-envelope"></i>
                <span>{props.t("Marketing tools")}</span>
              </Link>
            </li> */}

            <li>
              <Link to="/" className="has-arrow">
                <i className="mdi mdi-bullhorn"></i>
                <span>{props.t("Marketing Tools")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/Create-Design" onClick={tToggle}>
                    <i className="bx bxs-detail" />

                    <span>{props.t("New Design")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/select-Design" onClick={tToggle}>
                    <i className="bx bxs-detail" />

                    <span>{props.t("Saved Design")}</span>
                  </Link>
                </li>
              </ul>
            </li>

            {/* <li>
              <Link to="/knowledge-center" onClick={tToggle}>
                <i className="bx bx-envelope"></i>
                <span>{props.t("Knowledge Centre")}</span>
              </Link>
            </li> */}
            <li>
              <Link to="/" className="has-arrow">
                <i className="mdi mdi-book"></i>
                <span>{props.t("Knowledge Center")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/knowledge-circular" onClick={tToggle}>
                    <i className="bx bxs-detail" />

                    <span>{props.t("Circular")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/knowledge-brouchers" onClick={tToggle}>
                    <i className="bx bxs-detail" />

                    <span>{props.t("Brouchers")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/company-knowledge-guide" onClick={tToggle}>
                    <i className="bx bxs-detail" />
                    <span>{props.t("Document Repository")}</span>
                  </Link>
                </li>
              </ul>
            </li>





            <li>
              <Link to="/" className="has-arrow">
                <i className="mdi mdi-book"></i>
                <span>{props.t("Legal")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/terms-of-use" onClick={tToggle}>
                    <i className="bx bxs-detail" />

                    <span>{props.t("Terms of use")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/privacy-policy" onClick={tToggle}>
                    <i className="bx bxs-detail" />

                    <span>{props.t("Privacy Policy")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/cancellation-and-refund" onClick={tToggle}>
                    <i className="bx bxs-detail" />
                    <span>{props.t("Cancellation & Refund Policy")}</span>
                  </Link>
                </li>
              </ul>
            </li>


          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
